<app-page-header avatarHeader="true" [svg]="'v2:fi-br-question'">
    {{ 'Request Form Submission' }}
    <a mat-icon-button disableRipple
       [attr.aria-label]="routerBackButton.ariaLabel"
       [routerLink]="routerBackButton.route"
       [queryParams]="routerBackButton.queryParams">
        <mat-icon>arrow_back</mat-icon>
    </a>
</app-page-header>

<app-details-card-container [actionLines]="lines"
                            [showActions]="true"
                            [actions]="actions"
                            [loadingSubject$]="loadingSubject$"
                            (actionClicked)="$event.callback()">
    <mat-card>
        <mat-card-title>{{ 'Submitter Information' }}</mat-card-title>

        <mat-divider></mat-divider>

        <mat-card-content>
            <mat-list [loadingList]="!formSubmission" combineLines>
                <mat-list-item>
                    <span matListItemTitle>{{ 'Community' }}</span>
                    <span matListItemLine>{{ formSubmission?.form?.organization?.name }}</span>
                </mat-list-item>
                <mat-list-item>
                    <span matListItemTitle>{{ 'Unit Address' }}</span>
                    <span [innerHTML]="formSubmission?.unit?.address | addressLine" matListItemLine></span>
                </mat-list-item>
                <mat-list-item>
                    <span matListItemTitle>{{ 'Owners' }}</span>
                    <span matListItemLine>{{ formSubmission?.unit?.ownersOneLine }}</span>
                </mat-list-item>
            </mat-list>
        </mat-card-content>
    </mat-card>

    <mat-card>
        <mat-card-title>{{ 'Request Form Submission' }}</mat-card-title>

        <mat-divider></mat-divider>

        <mat-card-content>
            <mat-list [loadingList]="!formSubmission" combineLines>
                <mat-list-item statusChipLine>
                    <span matListItemTitle>{{ 'Status' }}</span>
                    <app-status-chip [loadingInitialData]="loadingInitialData"
                                     [statusId]="formSubmissionStatus?.id"
                                     [label]="'Form submission status'"
                                     [statuses]="formSubmissionStatuses"
                                     (statusSelected)="openStatusChange()"
                                     matListItemLine>
                    </app-status-chip>
                </mat-list-item>
                <mat-list-item>
                    <span matListItemTitle>{{ 'Submission Date' }}</span>
                    <span matListItemLine>{{ formSubmission?.createdAt | legfiDate:'MM/DD/YYYY' }}</span>
                </mat-list-item>
                <mat-list-item *ngIf="formSubmission?.unit?.owners[0]?.membership?.name !== formSubmission?.membership?.name">
                    <span matListItemTitle>{{ 'Submitted By' }}</span>
                    <span matListItemLine>{{ formSubmission?.membership?.name }}</span>
                </mat-list-item>
                <mat-list-item>
                    <span matListItemTitle>{{ 'Tags' }}</span>
                    <span matListItemLine>{{ formSubmission?.tagsOneLine }}</span>
                </mat-list-item>
            </mat-list>
        </mat-card-content>
    </mat-card>

    <mat-card>
        <mat-card-title>{{ 'Form Questions and Answers' }}</mat-card-title>

        <mat-divider></mat-divider>

        <mat-card-content>
            <mat-list [loadingList]="!formSubmission" [loadingLines]="3">
                <ng-template [ngForOf]="formSubmission?.answers" let-answer let-isLast="last" ngFor>
                    <ng-container [ngSwitch]="answer.question.type">
                        <mat-divider *ngSwitchCase="'hr'" [class.hidden]="isLast"></mat-divider>
                        <mat-list-item *ngSwitchCase="'plaintext'">
                            <span class="form-info-text" [innerHTML]="answer.question.label" matListItemLine></span>
                        </mat-list-item>
                        <mat-list-item *ngSwitchCase="'file'">
                            <span class="form-question"
                                  [innerHTML]="answer.question.label"
                                  [requiredMarker]="answer.question.isRequired"
                                  matListItemTitle>
                            </span>
                            <span *ngIf="answer.files.length === 0" class="form-answer" [innerHTML]="'--'" matListItemLine></span>
                            <span *ngIf="answer.files.length > 0" class="form-answer" matListItemLine>
                                <a *ngFor="let item of answer.files"
                                   class="form-answer"
                                   target="_blank"
                                   [id]="item.id"
                                   [href]="item.viewUrl"
                                   mat-flat-button linkButton disableRipple>
                                    <app-avatar-block [icon]="'open_in_new'">{{ item.fileName || '' }}</app-avatar-block>
                                </a>
                            </span>
                        </mat-list-item>
                        <mat-list-item *ngSwitchDefault>
                            <span class="form-question"
                                  [innerHTML]="answer.question.label"
                                  [requiredMarker]="answer.question.isRequired"
                                  matListItemTitle>
                            </span>
                            <span class="form-answer" [innerHTML]="answer.answer || '--'" matListItemLine></span>
                        </mat-list-item>
                    </ng-container>
                </ng-template>
            </mat-list>
        </mat-card-content>
    </mat-card>

    <app-attachments-card [modelType]="modelType" [model]="formSubmission"></app-attachments-card>

    <mat-card tableContent>
        <mat-card-header>
            <mat-card-title>{{ 'Approvals' }}</mat-card-title>
            <mat-card-title>{{ approvalCounts }}</mat-card-title>
        </mat-card-header>

        <mat-divider></mat-divider>

        <mat-card-content>
            <app-request-form-submission-approvals [formSubmissionId]="formSubmission?.id"
                                                   (approvalsLoaded)="updateApprovals($event)">
            </app-request-form-submission-approvals>
        </mat-card-content>
    </mat-card>

    <app-comments-card [modelType]="modelType" [model]="formSubmission"></app-comments-card>

    <app-notes-card [modelType]="modelType" [model]="formSubmission"></app-notes-card>
</app-details-card-container>
